module.exports = __webpack_public_path__ + "img/w34.8c72a17d.svg";